import { Component, HostListener, ViewChild } from '@angular/core';
import { CommonService } from '@services/app.common.service';
import { AuthenticationService } from '@services/authentication.service';
import { first } from 'rxjs/operators';
import { StatusCode } from './_shared/_enums/Common';
import { JTUserIdleService } from './_shared/userIdle/user-idle.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { TitleService } from '@services/title.service';

import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { UserInfo } from './_shared/_layout/app-footer/_footer.interfaces';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  @ViewChild('ConfirmLogoutModal', { static: true }) confirmLogoutModal?: ModalDirective;
  @ViewChild('RefreshTokenFaildedModal', { static: true }) refreshTokenFaildedModal?: ModalDirective;
  title = 'app';
  public refreshTokenFailedtimerCount = 0;
  public refreshTokenInProgress: boolean = false;
  public failedTokeninterval: any;
  public timerCount = 0;
  public refreshIntervalId: any;
  public KeepWorkingButtonText = "Messages.YesKeepWorking";
  public hideKeepWorkingButton: boolean = false;
  public logOutButtonText = "Messages.NoLogout";
  public isPassword = "text";
  public userInfo = {} as UserInfo;
  private sub: any;
  subscription: Subscription = Subscription.EMPTY;;
  public animationsDisabled = false;
  public modelShown = false;
  public keepAliveInprogress: boolean = false;
 
  constructor(private common: CommonService, private router: Router, private authService: AuthenticationService, private userIdle: JTUserIdleService, public titleService: TitleService) {
     
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.common.RemoveLocalStorage("refreshTokenInProgress");
      }
      else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.common.RemoveLocalStorage("refreshTokenInProgress");
        setTimeout(() => {
          this.initCountDownTimer();
        }, 2000);
        
      }
    });
    var userLang = navigator.language.split('-')[0]; // use navigator lang if available
    userLang = /(fr|en)/gi.test(userLang) ? userLang : 'en';
    this.common.SetLocalStorage('lang', userLang);
  }


  ngOnDestroy(): any {
    this.common.RemoveLocalStorage('refreshTokenInProgress');
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      clearInterval(this.failedTokeninterval);
    }
  }

  ngOnInit() {
    this.subscription = this.titleService.getMessage().subscribe(message => {
      if (message && message == 'refreshToken') {

        this.refreshToken(true);
      }
    });

    const clientSetting = this.common.getClientSettings();
    this.animationsDisabled = clientSetting.AnimationsDisabled;

    //  var userLang = navigator.language.split('-')[0]; // use navigator lang if available
    let userLang = clientSetting.ApplicationLanguage;

    userLang = !this.common.isNullOrWhiteSpace(userLang) ? userLang : 'en';


    this.common.SetLocalStorage('lang', userLang);
    //this.translate.setDefaultLang(userLang);
    //this.translate.use(userLang)
    //  .subscribe(() => {
    //  }, err => {
    //    console.error(`Problem with '${userLang}' language initialization.'`);
    //  });

    this.common.RemoveLocalStorage('refreshTokenInProgress');
    this.refreshIntervalId = setInterval(() => {
      this.refreshToken();
    }, 60 * 1000);


  }
  ngAfterViewInit() {
    this.refreshToken();
  }

  @HostListener('window:pageshow')
  public onPageShow() {
    this.redirectToLoginIfSignedOut();
  }

  private redirectToLoginIfSignedOut() {
    if (this.router.url.indexOf('/Login') == -1 && !this.authService.isUserLoggedIn()) {
      this.common.RedirectToLogin();
    }
  }

  isUserLoggedIn() {
    if (this.router.url.indexOf('/Login') == -1) {
      if (!this.authService.isUserLoggedIn()) {
        // this.openConfirmModal();
      } else {
        // this.closeConfirmModal();
      }
    }
  }
  

  public openConfirmModal() {
    this.isPassword = 'password';
    this.userInfo = this.common.GetLoggedinUserInfo();
    this.confirmLogoutModal?.show();
  }
  public initCountDownTimer() {

    // if (!this.authService.isUserLoggedIn())
    //  return;

    this.userIdle.stopWatching();
    const settings = this.common.getSettings();
    const clientSetting = settings.ClientSetting;
    let idleTimeOut = 2100;
    if (!this.common.isNullOrWhiteSpace(clientSetting)) {
      idleTimeOut = clientSetting.IdleTimeOut;
    }
    this.userIdle.setConfigValues({ idle: idleTimeOut, timeout: 300, ping: 300 });
    console.log('Moduel Regstration done startWatching:');
    this.userIdle.startWatching();
    this.modelShown = false;
    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => {
      if (!this.common.isNullOrWhiteSpace(count)) {
        const remainingTime = 300 - count;
        this.timerCount = remainingTime;
        // if (this.timerCount <= 0) {
        // this.common.logOut();
        // }

        if (this.authService.isUserLoggedIn()) {
          this.openConfirmModal();
        }
      }
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      this.common.RedirectToLogin();
    });

    this.userIdle.ping$.subscribe(() => {
      // this.refreshToken()
    }
    );



  }

  public closeConfirmModal() {
    this.isPassword = 'text';
    this.confirmLogoutModal?.hide();
  }

  public logout() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
    // this.common.logOut();
    this.common.RedirectToLogin();
  }



  public keepWorking() {

    this.KeepWorkingButtonText = 'Messages.Processing';
    this.refreshToken(true, true);
    this.userIdle.resetTimer();
    this.confirmLogoutModal?.hide();

  }

  public ManuallTokenRefresh() {
    if (this.authService.isUserLoggedIn()) {

      this.KeepWorkingButtonText = "Messages.Processing";
      //this.common.loader.show();
      this.common.RemoveLocalStorage("refreshTokenInProgress");
      this.refreshToken(true)
    }
    else {
      this.hideKeepWorkingButton = true;
      this.logOutButtonText = "Messages.BackToLogin"

    }
  }



  login() {
    this.confirmLogoutModal?.hide();
  }


  refreshToken(forceRefresh = false, closeModal = false) {
    const $this = this;

    if (!this.authService.isUserLoggedIn()) {
      return;
    }


    const currentDate = new Date();


    const lastRefreshTime = new Date(this.common.GetFromLocalStorage('lastTokenRefreshtime'));
    const difference = currentDate.getTime() - lastRefreshTime.getTime(); // This will give difference in milliseconds
    const resultInSeconds = Math.round(difference / 1000);

    // calculate remaining token time in seconds
    const tokenExpireDate = this.authService.GetTokenExpirationDate();
    let remainingTimeExpire = Math.round((tokenExpireDate.getTime() - currentDate.getTime()) / 1000);
    if (remainingTimeExpire <= 180) {
      if (this.refreshTokenFailedtimerCount == 0) {
        this.common.RemoveLocalStorage('refreshTokenInProgress');
        this.refreshTokenFailedtimerCount = remainingTimeExpire - 5;
        this.startRefreshTokenFailedTimer();
      }

      this.refreshTokenFaildedModal?.show();
    }



    const refreshTokenInProgressTime = new Date(this.common.GetFromLocalStorage('refreshTokenInProgress'));
    const remainingTime = Math.round((currentDate.getTime() - refreshTokenInProgressTime.getTime()) / 1000);
    if (remainingTime <= 10) {
      return;
    }


    if (resultInSeconds >= 300 || forceRefresh) {
      this.common.SetLocalStorage('refreshTokenInProgress', new Date());
      const lastToken = this.common.GetAccessToken();
      this.authService.refreshToken().pipe(first()).subscribe((res: any) => {
        this.refreshTokenInProgress = false;
        try {
          if (res.status == StatusCode.OK) {

            this.common.RemoveLocalStorage("refreshTokenInProgress");
            this.common.SetLocalStorage("lastTokenRefreshtime", new Date());
            this.common.SetAccessToken(res.resultData);
            if (closeModal) {
              this.modelShown = false;
              this.confirmLogoutModal?.hide();
              this.userIdle.resetTimer();

            }


            // manual token refersh code
            this.refreshTokenFaildedModal?.hide();
            //this.common.Loader.hide();
            this.refreshTokenFailedtimerCount = 0;
            clearInterval(this.failedTokeninterval);

            this.KeepWorkingButtonText = 'Messages.YesKeepWorking';
            // this.common.PostData(this.common.ApiUrls.SystemUser.RevokeToken, null, false, lastToken).then(function (data) {
            // });
          } else {
            this.KeepWorkingButtonText = 'Messages.YesKeepWorking';
            this.common.RemoveLocalStorage('refreshTokenInProgress');
          }

        } catch (e) {
          this.KeepWorkingButtonText = 'Messages.YesKeepWorking';
          this.common.RemoveLocalStorage('refreshTokenInProgress');
        }
      }, error => {
        this.KeepWorkingButtonText = 'Messages.YesKeepWorking';
        this.common.RemoveLocalStorage('refreshTokenInProgress');
      });
    }
  }

  startRefreshTokenFailedTimer() {
    this.failedTokeninterval = setInterval(() => {
      if (this.refreshTokenFailedtimerCount > 0) {
        this.refreshTokenFailedtimerCount--;
        if (this.refreshTokenFailedtimerCount <= 0) {
          this.common.RedirectToLogin();
        }
      }
    }, 1000);
  }






  keepAlive() {

    return;
    const $this = this;
    
    if (this.keepAliveInprogress) {
      return;
    }
    const lastPingTime = new Date(this.common.GetFromLocalStorage('lastPingtime'));
    const currentDate = new Date();

    const difference = currentDate.getTime() - lastPingTime.getTime(); // This will give difference in milliseconds
    const resultInMinutes = Math.round(difference / 60000);
    if (resultInMinutes >= 10) {
      this.keepAliveInprogress = true;
      $this.common.SetLocalStorage('lastPingtime', new Date());
      this.common.GetData(this.common.ApiUrls.System.KeepAlive, false).then(function (data) {
        if (data.status == StatusCode.OK) {
          $this.common.SetLocalStorage('lastPingtime', new Date());
          $this.keepAliveInprogress = false;
        } else {
          $this.keepAliveInprogress = false;
        }
      });


    }
  }
}
